module.exports = __webpack_public_path__ + "img/ER.c0c00a58.png";